import { ButtonPrimary } from '@/components/button'
import { Close } from '@/components/icons'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  onClose: () => void
}

export const ViewQualifyingBracketsModal = ({ open, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full flex flex-col gap-y-4 max-w-2xl transform overflow-hidden rounded-2xl bg-white px-6 py-4 text-left align-middle shadow-xl transition-all relative">
                <button
                  className="w-9 h-9 rounded-full bg-navy-900 bg-opacity-10 flex items-center justify-center ml-2 hover:bg-opacity-20 absolute right-2 top-2"
                  onClick={onClose}
                >
                  <Close className="text-navy-900" />
                </button>

                <Dialog.Title as="h3" className="text-xl text-navy-900 font-semibold">
                  {t('event.viewQualifyingPartners')}
                </Dialog.Title>

                <div className="px-10">
                  <p className="text-sm text-navy-900 text-opacity-70">{t('event.viewQualifyingPartnersDesc')}</p>
                </div>

                <div className="flex  justify-center gap-x-6">
                  <ButtonPrimary title={t('common.ok')} className="!py-[6px] !px-10 !rounded" onClick={onClose} />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
